type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

const DesktopMonitorIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 16 16',
    strokeColor = 'currentColor',
    strokeWidth = '1.5',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <rect
        x="1"
        y="3"
        width="14"
        height="10"
        rx="1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M5 13h6"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DesktopMonitorIcon;
